const normalizeSrc = (src: string) => {
  return src.startsWith('/') ? src.slice(1) : src;
};

export type CloudflareLoaderProps = {
  src: string;
  width: number;
  quality?: number;
};

export default function cloudflareLoader({
  src,
  width,
  quality,
}: CloudflareLoaderProps) {
  // // Skip transformation for SVGs
  if (src.toLowerCase().includes('.svg')) {
    if (/^https?:\/\//i.test(src)) return src;
    return src.startsWith('/') ? src : `/${src}`;
  }

  const params = [`width=${width}`];

  let optimizedQuality = quality;

  if (!optimizedQuality) {
    optimizedQuality = 80;

    if (width > 500) optimizedQuality = 75;
    if (width > 1000) optimizedQuality = 70;
  }

  params.push(`quality=${optimizedQuality}`);

  // Use modern formats for better compression
  params.push(`format=auto`);

  const paramsString = params.join(',');
  return `https://decodo.com/cdn-cgi/image/${paramsString}/${normalizeSrc(
    src
  )}`;
}
